import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../network/urls";
import { companyShortName, filterDataByDuration, mergeWithDefaultCFCData, mergeWithDefaultData } from "../../services/Functions";
import "./CfcDashboard.scss";
import CommercialServicesCardLoading from "../../components/commercialServicesCard/CommercialServicesCardLoading";
import DashboardHeaderLoading from "../../components/cfcDashboard/DashboardHeaderLoading";
// Lazy load DashboardHeader and InfoCard
const CommercialServicesCard = lazy(() => import("../../components/commercialServicesCard/CommercialServicesCard"));
const DashboardHeader = lazy(() => import("../../components/cfcDashboard/DashboardHeader"));

const CommercialOperations = () => {
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const { token, code, cfcLevelId,hierarchy } = useSelector(state => state.auth)

    const [hierarchicalCFCStats, setHierarchicalCFCStats] = useState([
        {
            cfcName: 'Circle CFC 1',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },

            ]
        },
        {
            cfcName: 'Circle CFC 2',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
               
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },

            ]
        },
        {
            cfcName: 'Circle CFC 3',
            servicesStats: [
                { service: "New Connections", pending: 120, attended: 21, total: 141 },
                {
                    service: "Bill Installments",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                {
                    service: "Due Date Extensions",
                    pending: 120,
                    attended: 21,
                    total: 141,
                },
                { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
                { service: "Reconnection", pending: 120, attended: 21, total: 141 },
                // { service: "Change of Load", pending: 120, attended: 21, total: 141 },
                // { service: "Change of Tariff", pending: 120, attended: 21, total: 141 },
            ]
        }

    ]);

    // Color palette for dynamic service cards
    const cardColors = ["#FFE2E5", "#EBDBFE", "#FEF5C0", "#FBE2CC", "#D4EDDA", "#CCE5FF", "#F8D7DA", "#E2E3E5"];

    // Service mapping for grouping related services in top cards
    const serviceMapping = {
        'Change of Name': 'Change of Attributes',
        'Change of Load': 'Change of Attributes',
        'Change of Tariff': 'Change of Attributes',
        'Change Of Attributes': 'Change of Attributes',
    };

    // Helper to split service name into title1 and title2
    const splitServiceName = (serviceName) => {
        const words = serviceName.split(' ');
        if (words.length === 1) {
            return { title1: serviceName, title2: '' };
        } else if (words.length === 2) {
            return { title1: words[0], title2: words[1] };
        } else {
            // Split roughly in half
            const midPoint = Math.ceil(words.length / 2);
            return {
                title1: words.slice(0, midPoint).join(' '),
                title2: words.slice(midPoint).join(' ')
            };
        }
    };

    const [serviceCards, setServiceCards] = useState([])

    const [cfcStats, setCFCStats] = useState({
        cfcName: 'Test Regional CFC',
        servicesStats: [
            {
                Service: "Due Date Extensions",
                Attended: 31,
                Pending: 142,
                Total: 173,
                Duration: "Progressive"
            },
            {
                Service: "Change of Tariff",
                Attended: 32,
                Pending: 101,
                Total: 133,
                Duration: "Progressive"
            },
            
            {
                Service: "New Connections",
                Attended: 208,
                Pending: 148,
                Total: 356,
                Duration: "Progressive"
            },
            
            {
                Service: "Bill Installments",
                Attended: 43,
                Pending: 77,
                Total: 120,
                Duration: "Progressive"
            },
            {
                Service: "Bill Installments",
                Attended: 8,
                Pending: 7,
                Total: 15,
                Duration: "Monthly"
            },
            {
                Service: "Bill Installments",
                Attended: 20,
                Pending: 15,
                Total: 35,
                Duration: "CurrentMonth"
            },
            
            {
                Service: "Change of Tariff",
                Attended: 1,
                Pending: 4,
                Total: 5,
                Duration: "Monthly"
            },
            {
                Service: "Due Date Extensions",
                Attended: 11,
                Pending: 6,
                Total: 17,
                Duration: "Monthly"
            },
            {
                Service: "New Connections",
                Attended: 20,
                Pending: 21,
                Total: 41,
                Duration: "Monthly"
            },
            {
                Service: "New Connections",
                Attended: 2,
                Pending: 4,
                Total: 6,
                Duration: "CurrentMonth"
            }
        ]
    },);

    const [officeCode, setOfficeCode] = useState(code)
    // Set initial cfcLevel based on hierarchy: regional(1,2)=2, circle(3)=3, division(4)=4
    const getInitialLevelId = () => {
        if (hierarchy == 1 || hierarchy == 2) return 2;
        if (hierarchy == 3) return 3;
        if (hierarchy == 4) return 4;
        return cfcLevelId;
    };
    const [levelId, setLevelId] = useState(getInitialLevelId())
    const [navigationHistory, setNavigationHistory] = useState([])

    const updateOfficeCode = (newCode, newLevelId) => {
        if (newCode) {
            // Save current state to history before navigating
            setNavigationHistory(prev => [...prev, { officeCode, levelId }])
            if (newLevelId !== undefined && newLevelId !== null) {
                setLevelId(newLevelId)
            } else {
                // Auto-increment level on drill-down: regional(2)→circle(3)→division(4)
                setLevelId(prev => prev + 1)
            }
            setOfficeCode(newCode)
        }
    }

    const goBack = () => {
        if (navigationHistory.length > 0) {
            const previous = navigationHistory[navigationHistory.length - 1]
            setNavigationHistory(prev => prev.slice(0, -1))
            setOfficeCode(previous.officeCode)
            setLevelId(previous.levelId)
        }
    }

    useEffect(() => {
        const getCFCStats = async () => {
            if (officeCode) {
                try {


                    // setViewBackdrop(true)
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    const formdata = new FormData();
                    formdata.append("officeCode", (officeCode == "10" || officeCode == "15") ? "1500001" : officeCode);

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: formdata,
                        redirect: "follow"
                    };

                    await fetch(cfpBaseUrl + "comman/getCFCDashboardStats", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            // setViewBackdrop(false)
                            if (result.status === "200") {
                                let cfcName = result.cfcInformation[0].cfcName
                                let cfcId = result.cfcInformation[0].cfcId
                                let cfcServices = result.data
                                let cfcServicesCumulative = result.Cumulative
                                // Always update primary card table with cfcServices
                                const mergedLowerCardData = mergeWithDefaultCFCData(cfcServices || [])

                                // First load: show hierarchy level name, drill-down: show API cfcName
                                const isFirstLoad = navigationHistory.length === 0;
                                let displayName = cfcName;
                                if (isFirstLoad) {
                                    if (hierarchy == 1 || hierarchy == 2) {
                                        displayName = companyShortName(code.slice(0, 2));
                                    } else if (hierarchy == 3) {
                                        displayName = 'Circle';
                                    } else if (hierarchy == 4) {
                                        displayName = 'Division';
                                    } else if (hierarchy == 5) {
                                        displayName = 'Subdivision';
                                    }
                                }

                                setCFCStats({
                                    cfcName: displayName,
                                    cfcId: cfcId,
                                    servicesStats: mergedLowerCardData
                                })

                                // Update top service cards from Cumulative data if available
                                if (cfcServicesCumulative) {
                                    const mergedData = mergeWithDefaultData(cfcServicesCumulative);
                                    if (mergedData) {
                                        const yearlyData = filterDataByDuration(mergedData, 'Progressive')
                                        const currentMonthData = filterDataByDuration(mergedData, 'CurrentMonth')

                                        // Get unique services and apply mapping for grouped services
                                        const serviceDataMap = {};
                                        yearlyData.forEach(data => {
                                            const mappedService = serviceMapping[data.service] || data.service;
                                            if (!serviceDataMap[mappedService]) {
                                                serviceDataMap[mappedService] = { yearly: 0, monthly: 0 };
                                            }
                                            serviceDataMap[mappedService].yearly += data.total;
                                        });
                                        currentMonthData.forEach(data => {
                                            const mappedService = serviceMapping[data.service] || data.service;
                                            if (!serviceDataMap[mappedService]) {
                                                serviceDataMap[mappedService] = { yearly: 0, monthly: 0 };
                                            }
                                            serviceDataMap[mappedService].monthly += data.total;
                                        });

                                        // Generate dynamic service cards
                                        const dynamicServiceCards = Object.keys(serviceDataMap).map((serviceName, index) => {
                                            const { title1, title2 } = splitServiceName(serviceName);
                                            return {
                                                service: serviceName,
                                                title1,
                                                title2,
                                                yearlyCounter: serviceDataMap[serviceName].yearly,
                                                month: new Date().toLocaleString('default', { month: 'short' }),
                                                monthlyCounter: serviceDataMap[serviceName].monthly,
                                                color: cardColors[index % cardColors.length],
                                            };
                                        });

                                        setServiceCards(dynamicServiceCards)
                                    }
                                }
                            }
                        })
                        .catch((error) => console.error(error));
                }
                catch (e) {
                    console.log(e, 'printing error!')
                }
            }
        }
        getCFCStats()
    }, [officeCode])

    useEffect(() => {
        const getChildrenCFCStats = async () => {
            if (officeCode) {
                try {


                    setViewBackdrop(true)
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    myHeaders.append("Content-Type", "application/json");

                    const raw = JSON.stringify({
                        "cfcLevel": levelId,
                        "cfcId": officeCode
                    });

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };

                    await fetch(cfpBaseUrl + "comman/getCFCChildernStatsOfficeWise", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            setViewBackdrop(false)
                            if (result.status === "200") {
                                let allChildrenCFCServices = result.data
                                let childrenList = result.chilledCFCDetails

                                // Collect all unique services across ALL children
                                const allUniqueServices = new Set();
                                allChildrenCFCServices.forEach((itm) => {
                                    allUniqueServices.add(itm.Service);
                                });

                                childrenList = childrenList.map((item) => (
                                    {
                                        ...item,
                                        servicesStats: allChildrenCFCServices.filter((itm) => itm.cfcId == item.cfcId)
                                    }
                                ))

                                // For each child, add default 0 entries for services missing from that child
                                const durations = ["Progressive", "Monthly", "CurrentMonth", "Daily"];
                                childrenList.forEach((item) => {
                                    if (item.servicesStats) {
                                        const existingKeys = new Set(
                                            item.servicesStats.map((s) => `${s.Service}-${s.Duration}`)
                                        );
                                        allUniqueServices.forEach((service) => {
                                            durations.forEach((duration) => {
                                                const key = `${service}-${duration}`;
                                                if (!existingKeys.has(key)) {
                                                    item.servicesStats.push({
                                                        Service: service,
                                                        Pending: 0,
                                                        Attended: 0,
                                                        Total: 0,
                                                        Duration: duration,
                                                    });
                                                }
                                            });
                                        });
                                        item.servicesStats = mergeWithDefaultCFCData(item.servicesStats);
                                    }
                                });
                                setHierarchicalCFCStats(childrenList)
                            }
                        })
                        .catch((error) => console.error(error));
                }
                catch (e) {
                    console.log(e, 'printing error!')
                }
            }
        }
        getChildrenCFCStats()
    }, [officeCode])

    return (
        <>
            <Box className="form-box">
                <div className="cfc-dashboard">
                    <Suspense fallback={<DashboardHeaderLoading />}>
                        <DashboardHeader
                            title="Customer Services"
                            serviceCards={serviceCards}
                        />
                    </Suspense>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '15px' }}>
                        <Suspense fallback={<CommercialServicesCardLoading />}>
                            <CommercialServicesCard item={cfcStats} primary={true} onGoBack={goBack} showBackButton={navigationHistory.length > 0} />
                        </Suspense>
                        {
                            hierarchicalCFCStats.map((item, index) => (
                                <div key={index}>
                                    <Suspense fallback={<CommercialServicesCardLoading />}>
                                        <CommercialServicesCard item={item} updateOfficeCode={updateOfficeCode} />
                                    </Suspense>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Box>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    );
};

export const getRowsData = () => [
    { service: "New Connections", pending: 120, attended: 21, total: 141 },
    {
        service: "Bill Installments",
        pending: 120,
        attended: 21,
        total: 141,
    },
    {
        service: "Due Date Extensions",
        pending: 120,
        attended: 21,
        total: 141,
    },
    { service: "Change of Attributes", pending: 120, attended: 21, total: 141 },
    // { service: "Change of Load", pending: 120, attended: 21, total: 141 },
    // { service: "Change of Tariff", pending: 120, attended: 21, total: 141 },
];

export default CommercialOperations;
